import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import VueRouter from 'vue-router'
import { $t } from '@/lib/i18n'
import config from 'config'
import VueCookie from 'vue-cookie'
import { getUrlParameter } from '@/helpers/url'
import ApiService from '@/services/ApiService'
import UserAgentService from '@/services/UserAgentService'
import CallbackService from '@/services/CallbackService'

Vue.use(VueRouter)
Vue.config.productionTip = false

// Init Vue prototypes
Vue.prototype.$t = $t
Vue.prototype.$api = new ApiService()
Vue.prototype.$agent = new UserAgentService(navigator.userAgent)
Vue.prototype.$callback = new CallbackService()

// Init css variables
if (config.app.primary) {
  document.documentElement.style.setProperty('--app-type-color', config.app.primary)
}
if (config.app.font) {
  document.documentElement.style.setProperty('--app-font-family', config.app.font)
}

// Init best locale

store.dispatch('LANG/setBestLocale').then(
  () => {
    store.dispatch('LANG/loadLangs', config.i18n.files).then(
      () => {
        new Vue({
          router,
          store,
          render: h => h(App)
        }).$mount('#app')
      }
    )
  }
)

// Set access token
const accessToken = VueCookie.get(config.api.cookie_access_token)
if (accessToken) {
  store.commit('API/SET_ACCESS_TOKEN', accessToken)
}

// Set iframeMode property
const iframeMode = getUrlParameter('iframe')
if (iframeMode && iframeMode === 'true') {
  store.commit('CONTENT/SET_IFRAME_MODE', true)
}

// Set country property
const country = getUrlParameter('country')
if (country) {
  store.commit('CONTENT/UPDATE_FORCED_COUNTRY', country)
}

// Set shouldAccept property
const shouldAccept = getUrlParameter('shouldAccept')
if (shouldAccept && shouldAccept === 'true') {
  store.commit('API/SET_SHOULD_ACCEPT', true)
}

// Set hideGsc property
const hideGsc = getUrlParameter('hideGsc')
if (hideGsc && hideGsc === 'true') {
  store.commit('CONTENT/SET_HIDE_GSC', true)
}
